import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import template from './Payment.vue';

import Button from '@/components/Button';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import payment from '@/store/modules/payment';
import store from '@/store';
import { Query, Meta } from '@/store/models';
import auth from '@/store/modules/auth';
import { PaymentType, Payment } from '@/store/models/payment';
import { router } from '@/_helpers';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		Button,
		MDTextFieldWithValidation
	},
	filters: {
		getType(type: PaymentType): string {
			if (type === PaymentType.CARD) {
				return 'Creditcard';
			}
			if (type === PaymentType.SEPA) {
				return 'SEPA';
			}
			return '-';
		},
		getFour(number: number): string {
			if (number < 1000) {
				return `0${number}`;
			}
			return `${number}`;
		},
		money(amount: number): string {
			let afterDigits: string = `${amount % 100}`;
			if (amount % 100 === 0) {
				afterDigits = '-';
			} else if (amount % 100 < 10) {
				afterDigits = `0${afterDigits}`;
			}
			return `€${amount / 100},${afterDigits}`;
		}
	}
})
export default class Payments extends Vue {
	loading: boolean = false;

	balance: number = 100;

	amount: string = '';

	form: any = {
		billingDetails: {
			name: ''
		}
	};

	async mounted(): Promise<void> {
		this.loading = true;

		await auth.getSelf(false);

		const query: Query = {
			query: {
				perPage: this.$route.query.perPage,
				previousLastId: this.$route.query.previousLastId,
				previousFirstId: this.$route.query.previousFirstId
			},
			customerID: auth.self.customerId
		};

		const arr = [];
		arr.push(this.get(query));
		arr.push(this.getBalance());

		await Promise.all(arr);

		this.loading = false;
	}

	get payments(): Payment[] {
		return payment.payments;
	}

	get meta(): Meta | null {
		return payment.meta ? payment.meta : null;
	}

	async get(query: Query): Promise<void> {
		this.loading = true;
		try {
			await payment.getAll(query);
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van de betaalmethoden`,
				color: 'error'
			});
		}
		this.loading = false;
	}

	async getBalance(): Promise<void> {
		this.loading = true;
		try {
			await payment.getBalance(auth.self.customerId);
			this.balance = payment.balance;
		} catch (error) {
			store.commit('openNotifier', {
				text: `Er ging wat fout tijdens het ophalen van het balans`,
				color: 'error'
			});
		}
		this.loading = false;
	}

	goTo(id: number): void {
		router.push({ name: 'paymentEdit', params: { PMid: id } } as any);
	}
}
